import { getData } from "@/utils/fetch";
import debounce from "debounce-promise";
import { defineStore } from "pinia";

let debouncedFetch = debounce(getData, 500);

export const useDashboardStore = defineStore({
  id: "dashboard",
  state: () => ({
    total: {},
    detailDipesan: {},
    detailBelumDipesan: {},
    detailScene: {},
    detailPostOrder: {},
  }),
  getters: {
    getData(state) {
      return state.total.data;
    },
  },
  actions: {
    async getTotal() {
      this.total = { loading: true };
      try {
        const result = await debouncedFetch("dashboard/total");
        this.total = { ...result.data };
      } catch (error) {
        console.log(error);
        this.total = { error };
      }
    },
    async getDetailDipesan(params) {
      this.detailDipesan = { loading: true };
      const dataparams = {
        limit: params?.limit || 25,
        offset: params?.offset || 0,
        q: params.q,
      };
      try {
        const result = await debouncedFetch("dashboard/dipesan", dataparams);
        this.detailDipesan = { ...result.data };
        console.log(this.detailDipesan);
      } catch (error) {
        console.log(error);
        this.detailDipesan = { error };
      }
    },
    async getDetailBelumDipesan(params) {
      this.detailBelumDipesan = { loading: true };
      const dataparams = {
        limit: params?.limit || 25,
        offset: params?.offset || 0,
        q: params?.q,
      };
      try {
        const result = await debouncedFetch(
          "dashboard/belum_dipesan",
          dataparams
        );
        this.detailBelumDipesan = { ...result.data };
      } catch (error) {
        console.log(error);
        this.detailBelumDipesan = { error };
      }
    },
    async getDetailScene(params) {
      this.detailScene = { loading: true };
      const dataparams = {
        limit: params?.limit || 25,
        offset: params?.offset || 0,
        q: params?.q,
      };
      try {
        const result = await debouncedFetch("dashboard/scene", dataparams);
        this.detailScene = { ...result.data };
      } catch (error) {
        console.log(error);
        this.detailScene = { error };
      }
    },
    async getDetailPostOrder(params) {
      this.detailPostOrder = { loading: true };
      const dataparams = {
        limit: params?.limit || 25,
        offset: params?.offset || 0,
        q: params?.q,
      };
      try {
        const result = await debouncedFetch("dashboard/post_order", dataparams);
        this.detailPostOrder = { ...result.data };
        console.log(this.detailPostOrder);
      } catch (error) {
        console.log(error);
        this.detailPostOrder = { error };
      }
    },
  },
});
